import React from 'react';
import { Link, useMatch } from 'react-router-dom';
import useHomeStore from '../../../../../store/homeStore';
import PricingModal from '../PricingModal/PricingModal';
import DownloadApiModal from '../DownloadApiModal/DownloadApiModal';
import ContactModal from '../ContactModal/ContactModal';
import FeaturesModal from '../FeaturesModal/FeaturesModal';
import NotificationModal from '../NotificationModal/NotificationModal';
import SearchPop from '../../../../features/Search/SearchPop';
import { Button, Modal } from 'antd';
import useSearchStore from '../../../../../store/searchStore';
import AssociateWithCompanyModal from '../../../../features/Login/AssociateWithCompanyModal';
import SubscriptionExpiredModal from '../../Subscription/SubscriptionExpiredModal';
import AuthenticateModal from '../../../../features/Login/AuthenticateModal';
import UserProfile from '../../../../features/UserProfile/UserProfile';
import ShoppingCart from '../../../../features/ShoppingCart/ShoppingCart';
import useAuthStore from '../../../../../store/authStore';

export const HeaderContainer: React.FC<{
  onNavigateHome: () => void;
  onCloseCart: () => void;
  onCloseUserProfile: () => void;
  onCloseAllModals: () => void;
  onCheckout: () => void;
}> = ({
  onNavigateHome,
  onCloseCart,
  onCloseUserProfile,
  onCloseAllModals,
  onCheckout,
}) => {
  const {
    showPricingModal,
    showDownloadApiModal,
    showContactModal,
    showFeaturesModal,
    showNotifications,
    showAssociateToCompany,
    showSubscriptionExpiredModal,
    showLogin,
    showSpectraModal,
    showSearch,
    showCart,
    showUserProfile,
  } = useHomeStore();
  const user = useAuthStore((state) => state.user);

  const isPaymentSuccessRoute = useMatch({
    path: '/payment/success',
    end: true,
  });

  return (
    <>
      <PricingModal
        visible={showPricingModal}
        onHandlePricingModalCancel={onNavigateHome}
        handleCloseAllModals={onCloseAllModals}
      />

      <DownloadApiModal
        visible={showDownloadApiModal}
        onHandleDownloadApiModalCancel={onNavigateHome}
      />

      <ContactModal
        visible={showContactModal}
        onHandleContactModalCancel={onNavigateHome}
      />

      <FeaturesModal
        visible={showFeaturesModal}
        onHandleFeaturesModalCancel={onNavigateHome}
        handleCloseAllModals={onCloseAllModals}
      />

      <NotificationModal
        visible={showNotifications}
        onHandleNotificationModalCancel={onNavigateHome}
      />

      <SearchPop
        visible={showSearch}
        searchID={(id) => useSearchStore.getState().setSearchId(id)}
        onHandleDatasetsModalCancel={onNavigateHome}
      />

      <Modal
        closable={false}
        keyboard={false}
        open={isPaymentSuccessRoute !== null}
        title='Your data order is being processed'
        footer={
          <Link to='/'>
            <Button>OK</Button>
          </Link>
        }
      >
        An email with a link to download the data will be sent to you within a
        few minutes. You will be redirected to the main page.
      </Modal>

      {showCart && <ShoppingCart close={onCloseCart} checkout={onCheckout} />}
      {showUserProfile && (
        <UserProfile close={onCloseUserProfile} user={user} />
      )}
      {showAssociateToCompany.status && <AssociateWithCompanyModal />}
      {showSubscriptionExpiredModal.status && <SubscriptionExpiredModal />}
      {(showLogin || showSpectraModal) && <AuthenticateModal />}
    </>
  );
};
